module.exports = __webpack_public_path__ + "static/img/male.bf3b8b09.png";